import { css } from 'styled-components';

import { customPropertiesColors } from './colors';
import { size } from './helpers';

export const customProperties = css`
  :root {
    ${customPropertiesColors};

    --border-radius: 3px;
    --main-gutter: ${size(2)};
    --main-gutter-negative: calc(var(--main-gutter) * -1);
    --heading-margin: ${size(2)};
    --heading-margin-tiny: ${size(0.5)};
    --heading-margin-small: ${size(1)};

    --font-weight-body: var(--font-weight-regular);
    --font-weight-link: var(--font-weight-medium);
    --font-weight-strong: var(--font-weight-bold);

    --icon-button-size: ${size(5.5)};

    // Custom properties specific to the market SE
    ${(props) => props.theme.market.seRoot} {
      --font-weight-strong: var(--font-weight-medium);
    }

    ${(props) => props.theme.breakpoint.Md} {
      --main-gutter: ${size(4)};
    }

    ${(props) => props.theme.breakpoint.Lg} {
      --main-gutter: ${size(5)};
    }
  }
`;
